import React from 'react'

export default function Backdrop ()
{
    return (
        <div className='bg-white w-full h-screen fixed top-0 right-0 z-10' ></div>
    )
}
